export function generateKey() {
  return Math.random().toString(36).substr(2, 9)
}



// WEBPACK FOOTER //
// ./src/mixins/keyGenerator.js